import React from 'react'
import Header from '../../Component/Header'
import Footer from '../../Component/Footer'
import Index from '../Index'

function LayoutIndex() {
  return (
    <>
      <Header/>
      <Index/>
      <Footer/>
    </>
  )
}

export default LayoutIndex
